import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import ActionsDropdown from '../../../../features/components/ActionsDropdown'

import usePermissions from '../../../../hooks/usePermissions'

import { insertIf } from '../../../../helpers/common'

import { RIGHT } from '../../../../constants/permissions'
import { RIGHT_TYPE_DIGITAL, RIGHT_TYPE_POSTS } from '../../../../forms/Multiplatform/Partnerships/RightForms/fields'

const RightActionDropdown = ({
  isAdvancedPartnership,
  openManageFilesClick,
  openRightEditForm,
  handleDeleteRight,
  type,
  id
}) => {
  const permissions = usePermissions()

  const getAdvancedPartnershipRightOptionText = useCallback(
    actionWord => {
      switch (type) {
        case RIGHT_TYPE_DIGITAL:
          return `${actionWord} campaign`
        case RIGHT_TYPE_POSTS:
          return `${actionWord} report`
        default:
          return actionWord
      }
    },
    [type]
  )

  const getDropdownOptions = rightId => {
    return [
      ...insertIf(!isAdvancedPartnership, {
        text: 'Manage files',
        onClickHandler: () => openManageFilesClick(rightId)
      }),
      ...insertIf(permissions.can('update', RIGHT), {
        text: isAdvancedPartnership ? getAdvancedPartnershipRightOptionText('Edit') : 'Edit right',
        onClickHandler: () => openRightEditForm(rightId)
      }),
      ...insertIf(permissions.can('delete', RIGHT), {
        text: isAdvancedPartnership ? getAdvancedPartnershipRightOptionText('Delete') : 'Delete right',
        onClickHandler: () => handleDeleteRight(rightId)
      })
    ]
  }

  return <ActionsDropdown options={getDropdownOptions(id)} />
}

RightActionDropdown.propTypes = {
  isAdvancedPartnership: PropTypes.bool.isRequired,
  openManageFilesClick: PropTypes.func.isRequired,
  openRightEditForm: PropTypes.func.isRequired,
  handleDeleteRight: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
}

export default RightActionDropdown
